import { replaceDoubleSlashWithSingleSlash } from "@enfusion-ui/utils";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any;

export async function restServerBase<T = string>(
  endpoint: string,
  restApiUrl: string,
  params?: Record<string, unknown>
): Promise<[T, Response]> {
  const headers = new Headers({
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "Multipart/form-data",
    ...(params?.headers as Record<string, string>),
  });

  let body = params?.body as string;
  if (!(params?.body instanceof FormData)) {
    headers.set("content-type", "text/plain");

    if (typeof params?.body === "object") {
      headers.set("content-type", "application/json");
      body = JSON.stringify(body);
    }
  }

  const config: RequestInit = {
    method: params?.body ? "POST" : "GET",
    ...params,
    body,
    headers,
  };
  const REQ_URL = `${restApiUrl || ""}${replaceDoubleSlashWithSingleSlash(
    `${endpoint.startsWith("/") ? "" : "/"}${endpoint}`
  )}`;
  console.info(`[REST] ${config.method} ${REQ_URL}`);

  const response = await window.fetch(REQ_URL, config);

  if (response.status === 418) {
    console.info(`[REST]: auth conflict (${response.status}): ${endpoint}`);
  }

  if (response.status === 503) {
    console.info(`[REST]: server issue (${response.status}): ${endpoint}`);
  }

  if (response.status === 401 || response.status === 403) {
    console.info(`[REST]: auth error (${response.status}): ${endpoint}`);
  }

  if (response.headers.get("Content-Type")?.startsWith("application/json")) {
    const json = (await response.json()) as T;
    return [json, response];
  }

  return [(await (response.text() as unknown)) as T, response];
}

export async function restServer<T = string>(
  endpoint: string,
  restApiUrl: string,
  params?: Record<string, unknown>
): Promise<T> {
  const res = await restServerBase<T>(endpoint, restApiUrl, params);
  return res[0];
}
